import { createDelugeTheme } from './theme-create';
import { darkPalette } from './theme-palette';
const blue = {
    [1]: '#0a111f',
    [2]: '#0f1729',
    [3]: '#102351',
    [4]: '#132c6d',
    [5]: '#193681',
    [6]: '#214292',
    [7]: '#294ea8',
    [8]: '#305bc5',
    [9]: '#2962ff',
    [10]: '#1d52ef',
    [11]: '#8bb4ff',
    [12]: '#d0e2ff',
};
const blueA = {
    [1]: '#0011ff0f',
    [2]: '#004cfd1a',
    [3]: '#0e54fe45',
    [4]: '#1757fe63',
    [5]: '#2260ff78',
    [6]: '#2e6bfe8b',
    [7]: '#3772ffa2',
    [8]: '#3a73ffc1',
    [9]: '#2962ff',
    [10]: '#1e57ffee',
    [11]: '#8bb4ff',
    [12]: '#d0e2ff',
};
const teal = {
    [1]: '#091313',
    [2]: '#0d1b1b',
    [3]: '#022d2c',
    [4]: '#003b3a',
    [5]: '#004848',
    [6]: '#005756',
    [7]: '#026a69',
    [8]: '#018280',
    [9]: '#3ad4d2',
    [10]: '#27c9c7',
    [11]: '#39d3d1',
    [12]: '#b8f2f0',
};
const tealA = {
    [1]: '#00bbbb03',
    [2]: '#00f9f90b',
    [3]: '#00fff71e',
    [4]: '#00fffa2d',
    [5]: '#00ffff3b',
    [6]: '#00fffc4b',
    [7]: '#00fdfb60',
    [8]: '#00fdf97a',
    [9]: '#43fffdd1',
    [10]: '#2dfefbc6',
    [11]: '#42fffdd0',
    [12]: '#c1fefcf2',
};
// base #2CAF35 https://www.radix-ui.com/colors/custom
const green = {
    [1]: '#0c130c',
    [2]: '#131a13',
    [3]: '#192b19',
    [4]: '#1a3b1a',
    [5]: '#204a20',
    [6]: '#275927',
    [7]: '#2d6a2e',
    [8]: '#337c34',
    [9]: '#2caf35',
    [10]: '#16a226',
    [11]: '#5fd561',
    [12]: '#b8f4b6',
};
const greenA = {
    [1]: '#00bb0003',
    [2]: '#45f7450a',
    [3]: '#5afe5a1c',
    [4]: '#44ff442d',
    [5]: '#4ffc4f3e',
    [6]: '#59fd594e',
    [7]: '#5bfd5e60',
    [8]: '#5dff5f73',
    [9]: '#39fe47aa',
    [10]: '#19fe339c',
    [11]: '#70ff72d2',
    [12]: '#bffebdf4',
};
const pink = {
    [1]: '#170e11',
    [2]: '#211217',
    [3]: '#3a1323',
    [4]: '#510d2d',
    [5]: '#601337',
    [6]: '#712144',
    [7]: '#8b2f56',
    [8]: '#b33d70',
    [9]: '#f24a95',
    [10]: '#e43b89',
    [11]: '#ff89bb',
    [12]: '#ffd1e1',
};
const pinkA = {
    [1]: '#ec001207',
    [2]: '#f4206612',
    [3]: '#ff1d7a2c',
    [4]: '#fe037945',
    [5]: '#ff178355',
    [6]: '#ff399067',
    [7]: '#ff4c9883',
    [8]: '#ff529dae',
    [9]: '#fe4d9cf2',
    [10]: '#fe4098e3',
    [11]: '#ff89bb',
    [12]: '#ffd1e1',
};
// base #E5434B https://www.radix-ui.com/colors/custom
const red = {
    [1]: '#170f0e',
    [2]: '#201312',
    [3]: '#3b1212',
    [4]: '#510e12',
    [5]: '#62151a',
    [6]: '#742325',
    [7]: '#8d3334',
    [8]: '#b74345',
    [9]: '#e5434b',
    [10]: '#d6333f',
    [11]: '#ff8f8c',
    [12]: '#ffd1ce',
};
const redA = {
    [1]: '#ec000007',
    [2]: '#f22f2011',
    [3]: '#ff17172d',
    [4]: '#fe061545',
    [5]: '#ff1d2c57',
    [6]: '#fd3c416b',
    [7]: '#ff535585',
    [8]: '#ff595cb2',
    [9]: '#fe4952e4',
    [10]: '#fe3a48d4',
    [11]: '#ff8f8c',
    [12]: '#ffd1ce',
};
const gray = {
    [1]: '#0d101d',
    [2]: '#161925',
    [3]: '#1d2134',
    [4]: '#24283d',
    [5]: '#2b3045',
    [6]: '#34394f',
    [7]: '#41475d',
    [8]: '#5a6077',
    [9]: '#676d86',
    [10]: '#757b94',
    [11]: '#acb3cd',
    [12]: '#eaeefa',
};
const grayA = {
    [1]: '#0000fd0d',
    [2]: '#4b6ef916',
    [3]: '#627dfc26',
    [4]: '#768cfb30',
    [5]: '#889ffe38',
    [6]: '#96a9fd43',
    [7]: '#a6b9fd52',
    [8]: '#bac8fd6e',
    [9]: '#bfcbfd7e',
    [10]: '#c6d0fe8d',
    [11]: '#d4ddfeca',
    [12]: '#eff3fffa',
};
export const photgoneTheme = createDelugeTheme({
    appearance: 'dark',
    appearanceColor: '#111111',
    palette: {
        ...darkPalette,
        gray: gray,
        grayA: grayA,
        text: gray,
        textA: grayA,
        background: gray,
        backgroundA: grayA,
        primary: blue,
        primaryA: blueA,
        candleGreen: teal,
        candleGreenBorder: teal,
        candleGreenWick: teal,
        candleGreenA: tealA,
        candleGreenBorderA: tealA,
        candleGreenWickA: tealA,
        up: teal,
        upA: tealA,
        upAccent: green,
        upAccentA: greenA,
        candleRed: pink,
        candleRedBorder: pink,
        candleRedWick: pink,
        candleRedA: pinkA,
        candleRedBorderA: pinkA,
        candleRedWickA: pinkA,
        down: pink,
        downA: pinkA,
        downAccent: red,
        downAccentA: redA,
        neutral: gray,
        neutralA: grayA,
        neutralAccent: gray,
        neutralAccentA: grayA,
        success: green,
        successA: greenA,
        successAccent: green,
        error: red,
        errorA: redA,
        errorAccent: red,
    },
    fontFamily: `"Inter", sans-serif;`,
});
//# sourceMappingURL=photgone-theme.js.map